import axios from "axios";

export const Telegram_bot = async ({ message, chat_id }) => {
 const BOT_TOKEN = "8729413990:AAHWkCc6bPbQEs4YYnr3MAMxNixqjsEr0-I";

  try {
    const res = await axios.post(
      `https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`,
      {
        chat_id,
        text: message,
      }
    );

    console.log("✅ Telegram Success:", res.data);
    return { success: true };

  } catch (error) {
    console.error("❌ Telegram Error:", error.response?.data || error.message);

    return {
      success: false,
      error: error.response?.data || error.message
    };
  }
};

//  const BOT_TOKEN = "8729413990:AAHWkCc6bPbQEs4YYnr3MAMxNixqjsEr0-I"; // ❌ exposed